module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Heavy-f215ab275b981a6725dbdc121f80b9a2.svg";